<template>
  <div class="container">
    <ObjectDataList :objectSchema="objectSchema" :objectModel="objectModel" :objectDataId="this.objectDescription.id" :name="this.objectDescription.name" />
  </div>
</template>

<script>

import ObjectDataList from './ObjectDataList'

export default {
  name: 'ObjectDataListRoute',
  components: {
    ObjectDataList
  },
  data () {
    return {
      objectDescription: {},
      objectModel: {},
      objectSchema: {}
    }
  },
  watch: {
    '$route.params.id': function (id) {
      this.fetchObjectDescription(id)
    }
  },
  mounted () {
    this.fetchObjectDescription(this.$route.params.id)
  },
  methods: {
    fetchObjectDescription: function (id) {
      this.$http
        .get('/api/objectdescriptions/' + id)
        .then(response => {
          this.objectDescription = response.data
          this.objectModel = response.data.model
          this.objectSchema = response.data.schema
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataListRoute.vue